module.exports = __webpack_public_path__ + "assets/img/xddbg1.0c49499a.png";